import React from 'react';

function OnboardingLineIcon() {
    return (
        <>
            <svg
                width="218"
                height="1"
                viewBox="0 0 218 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <line x1="0.25" y1="0.5" x2="218" y2="0.5" stroke="#D9D9D9" />
            </svg>
        </>
    );
}

export default OnboardingLineIcon;
